import './styles.scss';

import LottieAnimation from './animation.json';
import Lottie from 'lottie-react';

const AnimatedLoader = ({ className = '', onComplete = () => {} }) => {
  return (
    <div className={`animated-loader ${className}`}>
      <Lottie
        loop={true}
        autoplay={true}
        style={{
          maxWidth: '100px',
          maxHeight: '100px',
          transform: 'translate(0, -50%)',
        }}
        animationData={LottieAnimation}
        onComplete={onComplete}
      />
    </div>
  );
};

export default AnimatedLoader;
